export const apiCreate = (): string => 'users/permissions/create'
export const apiList = (id?: string): string =>
  !id ? 'users/permissions/' : `users/permissions/view/${id}`
export const apiUpdate = (id: string): string =>
  `users/permissions/update/${id}`
export const apiDelete = (id: string): string =>
  `users/permissions/delete/${id}`
